import React from 'react';
import PropTypes from 'prop-types';

const SocialAvatarImage = props => {
  const { facebookId, className, alt, imageUrl } = props;

  const avatar =
    imageUrl ||
    (facebookId
      ? `https://graph.facebook.com/${facebookId}/picture?type=large`
      : '/webclient/sk_core/images/placeholder_avatar.png');

  return <img src={avatar} className={className} alt={alt} />;
};

SocialAvatarImage.defaultProps = {
  alt: '',
};

SocialAvatarImage.propTypes = {
  facebookId: PropTypes.string,
  className: PropTypes.string,
  alt: PropTypes.string,
  imageUrl: PropTypes.string,
};

export default SocialAvatarImage;
